import { HourglassFilled } from "@ant-design/icons";
import { selectMerchant } from "@redux";
import { Progress } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
interface IProps {
    onClose: () => void;
    text: string;
    amount: number;
    countItem: number;
}

export default function PopupPrecessingProgress({ onClose, text, amount, countItem }: IProps) {
    const { themes } = useSelector(selectMerchant);
    const { t } = useTranslation();

    const percentTotal = (countItem / amount) * 100;
    const percent = Number(percentTotal).toFixed(0);
    return (
        <StyledPopupWarning themeColor={themes?.themeColor!}>
            <div className="box-popupconfirm">
                <div className="title">
                    <span className="text-headers">{text}</span>
                    {/* <div className="text-sub-header"></div> */}
                    <div className="btn-popupconfirm">
                        <div className="layout-progrss">
                            <HourglassFilled spin />
                            <span>{`${countItem}/${amount}`}</span>
                            <Progress percent={Number(percent)} size="small" status="active" />
                        </div>
                    </div>
                </div>
            </div>
        </StyledPopupWarning>
    );
}

const StyledPopupWarning = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 65px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .btn-popupconfirm {
            margin-top: 16px;
            width: 100%;
            .btn-cancel {
                display: flex;
                padding: 14.5px 32px;
                justify-content: center;
                align-items: center;
                gap: 8px;
                align-self: stretch;
                border-radius: 14px;
                background: ${(p) => p.themeColor};
                border: none;
                color: #fff;
                text-align: center;
                font-size: 13px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
            .layout-progrss {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
                font-size: 12px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        flex-direction: column;
        .image {
            margin-bottom: 10px;
        }
        .text-sub-header {
            text-align: center;
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
        }
        .text-headers {
            font-size: 14px;
            /* line-height: 21px; */
            color: #000;
            font-weight: 600;
            margin-top: -3rem;
            line-height: 18px;
        }
    }
`;
